/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Header from './Classes/Header';
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import SideNav from './Classes/SideNav';
import LazyLoad from 'vanilla-lazyload';
import FrontpageVideo from './Classes/FrontpageVideo';
import ResponsiveTable from "./Classes/ResponsiveTable";
import Table from "./Classes/Table";
import XDownloader from "./Classes/XDownloader";

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

import Accordion from './Classes/Accordion';
import SingleAccordion from './Classes/SingleAccordion';


import CountUpNumbers from './Classes/CountUpNumbers';

import Gri from './Classes/Gri';
import Link from './Classes/Link';

import PDFReplaceStageLinksToLive from './Classes/PDFReplaceStageLinksToLive';
import Corrections from './Classes/Corrections';

import PrevNextBack from './Classes/PrevNextBack';
import TableIconReplacer from './Classes/TableIconReplacer';
import Anchor from './Classes/Anchor';
import NswowAccordion from './Classes/NswowAccordion';

var headerInstance = null;
var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;
var sideNavInstance = null;

var jumpInstance = null;
var youtubeLinksInstance = null;
var FrontpageVideoInstance = null;
var accordionInstance = null;
var singleAccordionInstance = null;
var nswowAccordionInstance = null;

var countUpInstance = null;
var griInstance = null;
var linkInstance = null;

var pdfReplaceStageLink = null;
var tableInstance = null;

var correctionInstance = null;

var prevNextBack = null;
var tableIconReplacerInstance = null;
var anchor = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }



  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  // pdfReplaceStageLink = new PDFReplaceStageLinksToLive({
  //   anchors: 'a'
  // });
  anchor = new Anchor();

  headerInstance = new Header();
  sideNavInstance = new SideNav();
  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  FrontpageVideoInstance = new FrontpageVideo();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.force-responsive-table .ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 1,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: ':not(.force-responsive-table) .ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });


  /*downloaderInstance = new XDownloader({
    downloadText: "Download Excel", //Can be empty if you want to use an icon instead
    backgroundColor: "6ab04c", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
    borderColor: '95afc0', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'title', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-line_dots'
  });*/

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head'
  });

  singleAccordionInstance = new SingleAccordion({
    accordions: '.js-single-accordion',
    toggles: '.js-single-accordion-toggle'
  });

  nswowAccordionInstance = new NswowAccordion();

  countUpInstance = new CountUpNumbers({
    numbersSelector: '.js-keyfigure-number',
    classIn: 'in-viewport',
    classOut: 'not-in-viewport',
    langArray: ['de-DE','fr-FR'],
    decimalArray: [',', ','],
    thousandSepArray: [' ',' '],
  });

  correctionInstance = new Corrections();

  griInstance = new Gri();

  linkInstance = new Link();

  tableInstance = new Table();

  prevNextBack = new PrevNextBack({
    backPlaceholderSelector: '.js-pnb__back',
    prevPlaceholderSelector: '.js-pnb__prev',
    nextPlaceholderSelector: '.js-pnb__next',
    backSelector: '.js-menu__back',
    prevSelector: '.js-menu__prev',
    nextSelector: '.js-menu__next'
  });

  tableIconReplacerInstance = new TableIconReplacer();

});
